import { Component, OnInit } from '@angular/core';

import { Consorcio } from '../../model/consorcio';
import { IlgReporteInventario } from '../../model/ilg-reporte-inventario';
import { ConsorciosService } from '../../services/consorcios.service';
import { ReporteInventarioService } from '../../services/reporte-inventario.service';

@Component({
  selector: 'app-ilg-reporte-inventario',
  templateUrl: './ilg-reporte-inventario.component.html',
  styleUrls: ['./ilg-reporte-inventario.component.css']
})
export class IlgReporteInventarioComponent implements OnInit {

   public fechaActual: Date;
  public filtro: boolean;

  public codigoSucursal: string;
  public consorcio: Consorcio;
  public consorcios: Consorcio[];
  public inventarios: IlgReporteInventario[];
  public _filtro: string;
  public codigoArticulo: string;
  public nombreArticulo: string;
  public usuario: string;

  public buscando: boolean;
  public criterio: any;
  public query: any;

  constructor(
    private _consorcioService: ConsorciosService,
    private _inventario: ReporteInventarioService
  ) { }


  ngOnInit() {
    this._filtro = "";
    this.inventarios = [];
    this.buscando = false;
    this.usuario = sessionStorage.getItem("login");
    this.codigoArticulo = "";
    this.nombreArticulo = "";
    this.fechaActual = new Date();
    this.filtro = true;
    this.cargarConsorcios();
  }


  cargarConsorcios() {

    this.query = { "email": sessionStorage.getItem("login") };

    this._consorcioService.getConsorciosUsuario(this.query)
      .subscribe(
      data => { this.consorcios = data; },
      err => {
        console.log(err);
        this.buscando = false;
      });
  }

  filtroToggle() {
    this.filtro = !this.filtro;
  }

  realizarConsulta() {
    if (this.consorcio === undefined) {
      return;
    }
    this.buscando = true;
    this.query = { "ETIQUETA": "INVENTARIO", "QUERY":this.consorcio.codigoConsorcio};
    this._inventario.getIlgReporteInventario(this.query)
      .subscribe(
      data => {
        console.clear();
        console.log("========================== REPORTE ===============================");
        console.log(data);
        this.inventarios = data;
        this.buscando = false;
      },
      err => {
        this.buscando = false;
        console.log(err._body);
      });

    this.filtro = false;
  }


  exportar() {

    var ar = this.inventarios;

    //comprobamos compatibilidad
    if (window.Blob && (window.URL)) {
      var contenido = "", d = new Date(), blob, _reader, save, clicEvent;
      //creamos contenido del archivo
      for (var i = 0; i < ar.length; i++) {
        //construimos cabecera del csv
        if (i == 0)
          contenido += Object.keys(ar[i]).join(";") + "\n";
        //resto del contenido
        contenido += Object.keys(ar[i]).map(function (key) {
          return ar[i][key];
        }).join(";") + "\n";
      }
      //creamos el blob
      blob = new Blob(["\ufeff", contenido], { type: 'text/csv' });
      //creamos el reader
      _reader = new FileReader();
      _reader.onload = function (event) {
        //escuchamos su evento load y creamos un enlace en dom
        save = document.createElement('a');
        save.href = event.target.result;
        save.target = '_blank';
        //aquí le damos nombre al archivo
        save.download = "ReporteArtículos" + d.getDate() + "_" + (d.getMonth() + 1) + "_" + d.getFullYear() + ".csv";
        try {
          //creamos un evento click
          clicEvent = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': true
          });
        } catch (e) {
          //si llega aquí es que probablemente implemente la forma antigua de crear un enlace
          clicEvent = document.createEvent("MouseEvent");
          clicEvent.initEvent('click', true, true);
        }
        //disparamos el evento
        save.dispatchEvent(clicEvent);
        //liberamos el objeto window.URL
        (window.URL).revokeObjectURL(save.href);
      }
      //leemos como url
      _reader.readAsDataURL(blob);
    } else {
      //el navegador no admite esta opción
      alert("Su navegador no permite esta acción");
    }
  }

  imprimir() {
    let contenido, ventana;
    contenido = document.getElementById('print-section').innerHTML;
    ventana = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    ventana.document.open();
    ventana.document.write(`
      <html>
        <head>
          <title>Print tab</title>
          <link rel="stylesheet" href="reporte-inventario.component.css" type="text/css" media="print"/>
          <style>
          //........Customized style.......
          </style>
        </head>
    <body onload="window.print();window.close()">${contenido}</body>
      </html>`
    );
    ventana.document.close();
  }


}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/components/ilg-reporte-inventario/ilg-reporte-inventario.component.ts